<script lang="ts">
  export let svgStyles: string = ''
</script>

<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" class={svgStyles}>
  <circle cx="9" cy="9" r="9" fill="url(#paint0_linear_6241_1510)" />
  <defs>
    <linearGradient
      id="paint0_linear_6241_1510"
      x1="2.60699"
      y1="1.97817"
      x2="15.9432"
      y2="18"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#24CAFF" />
      <stop offset="0.7" stop-color="#FDB1A8" />
      <stop offset="1" stop-color="#FFA564" />
    </linearGradient>
  </defs>
</svg>
